<template>
    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="17" viewBox="0 0 18 17" fill="none">
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M2 1.99219C1.86193 1.99219 1.75 2.10412 1.75 2.24219V6.40229C1.75 6.54036 1.86193 6.65229 2 6.65229H5.14042C5.55463 6.65229 5.89042 6.98808 5.89042 7.40229V15.2422C5.89042 15.3803 6.00235 15.4922 6.14042 15.4922H16C16.1381 15.4922 16.25 15.3803 16.25 15.2422V2.24219C16.25 2.10412 16.1381 1.99219 16 1.99219H2ZM0.25 2.24219C0.25 1.27569 1.0335 0.492188 2 0.492188H16C16.9665 0.492188 17.75 1.27569 17.75 2.24219V15.2422C17.75 16.2087 16.9665 16.9922 16 16.9922H6.14042C5.17392 16.9922 4.39042 16.2087 4.39042 15.2422V8.15229H2C1.0335 8.15229 0.25 7.36879 0.25 6.40229V2.24219Z"
            fill="#5625CC"
        />
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M12.6748 10.9316V3.68164H14.1748V11.6816C14.1748 12.0959 13.839 12.4316 13.4248 12.4316H8.4248V10.9316H12.6748Z"
            fill="#5625CC"
        />
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M7.89459 12.212C7.60169 11.9191 7.60169 11.4442 7.89459 11.1513L10.0159 9.02999L11.0766 10.0907L9.48558 11.6816L11.0766 13.2726L10.0159 14.3333L7.89459 12.212Z"
            fill="#5625CC"
        />
    </svg>
</template>
<script>
export default {
    name: "EnterSvg",
};
</script>
